import clsx from 'clsx';
import moment from 'moment';
import { IContaBancaria } from '../../interfaces/IModuloBancario';

const brl = (valor: number | null | undefined) =>
    valor === null || valor === undefined ? '—' : valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const data = (valor: string | null | undefined) => (valor ? moment(valor).format('DD/MM/YYYY') : '—');

export const descreverConta = (c: IContaBancaria) =>
    `Banco ${c.banco}${c.agencia ? ` · Ag. ${c.agencia}` : ''} · Conta ${c.conta}${c.descricao ? ` (${c.descricao})` : ''}`;

interface Props {
    contas: IContaBancaria[];
    onNova: () => void;
    onEditar: (conta: IContaBancaria) => void;
}

// DEVN3-767 — contas bancárias da empresa, ligadas à conta contábil de Banco ou Caixa.
export default function ContasBancarias({ contas, onNova, onEditar }: Props) {
    return (
        <div className='card card-flush mb-4'>
            <div className='card-header align-items-center'>
                <h3 className='card-title fw-bold'>Contas bancárias</h3>
                <button className='btn btn-sm btn-primary' onClick={onNova}>
                    <i className='fas fa-plus me-1'></i>Nova conta
                </button>
            </div>
            <div className='card-body pt-0'>
                {contas.length === 0 ? (
                    <div className='text-muted py-4'>
                        Nenhuma conta bancária cadastrada. Cadastre as contas da empresa ou envie um OFX na etapa Arquivos: a conta lida no arquivo pode ser cadastrada direto.
                    </div>
                ) : (
                    <div className='table-responsive'>
                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'>
                            <thead>
                                <tr className='fw-bold text-muted'>
                                    <th>Conta bancária</th>
                                    <th>Conta contábil</th>
                                    <th>Último extrato aceito</th>
                                    <th className='text-end'>Saldo final</th>
                                    <th className='text-center'>Pendências</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {contas.map(c => (
                                    <tr key={c.id} className={clsx(!c.ativo && 'opacity-50')}>
                                        <td>{descreverConta(c)}{!c.ativo && <span className='badge badge-light ms-2'>inativa</span>}</td>
                                        <td>
                                            {c.contaContabil}
                                            {c.cartaoId
                                                ? <span className='text-muted ms-1'>{c.cartaoDescricao}</span>
                                                : <span className='text-danger ms-1' title='A conta contábil não existe como Banco/Caixa nesta esteira'><i className='fas fa-exclamation-triangle text-danger'></i></span>}
                                        </td>
                                        <td>{c.ultimoPeriodoInicio ? `${data(c.ultimoPeriodoInicio)} a ${data(c.ultimoPeriodoFim)}` : <span className='text-muted'>nenhum</span>}</td>
                                        <td className='text-end'>{brl(c.ultimoSaldoFinal)}</td>
                                        <td className='text-center'>{c.pendentes > 0 ? <span className='badge badge-light-warning'>{c.pendentes}</span> : '—'}</td>
                                        <td className='text-end'>
                                            <button className='btn btn-sm btn-icon btn-light' title='Editar' onClick={() => onEditar(c)}>
                                                <i className='fas fa-pen'></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}
